import CloudySun from '@/src/assets/svgs/CloudySun'
import { FlightTimingSlot, timeRangeMap } from '@/src/hooks/srp/flightTimingFilterManager'
import { DarkModeOutlined, WbSunnyOutlined } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

const SEODepartureTimingFilter = () => {
    const tFilters = useTranslations('srpFilters')
    const title = tFilters('timeFilterCta')
    const timeSlots: FlightTimingSlot[] = useMemo(
        () => [
            {
                label: tFilters('timeFilter1', { time: '6' }),
                subLabel: 'Midnight - 6 am',
                intlLabel: '12am_6am',
                value: '0600',
                time: timeRangeMap['0600'],
                icon: CloudySun
            },
            {
                label: tFilters('timeFilter2', { time1: '6', time2: '12' }),
                subLabel: '6 am - Noon',
                intlLabel: '6am_12pm',
                value: '1200',
                time: timeRangeMap['1200'],
                icon: WbSunnyOutlined
            },
            {
                label: tFilters('timeFilter3', { time1: '12', time2: '6' }),
                subLabel: 'Noon - 6 pm',
                intlLabel: '12pm_6pm',
                value: '1800',
                time: timeRangeMap['1800'],
                icon: CloudySun
            },
            {
                label: tFilters('timeFilter4', { time: '6' }),
                subLabel: '6 pm - Midnight',
                intlLabel: '6pm_12am',
                value: '2000',
                time: timeRangeMap['2000'],
                icon: DarkModeOutlined
            }
        ],
        []
    )

    return (
        <Box
            sx={{
                p: 2,
                borderBottom: 1,
                borderColor: 'grey.200',
                '&:last-child': {
                    borderBottom: 0
                }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'grey.900' }}>
                    {title}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* Departing flight section */}
                <Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
                        {timeSlots?.map(slot => (
                            <Button
                                key={slot.value}
                                variant={slot.isSelected ? 'contained' : 'outlined'}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    p: 0.75,
                                    borderRadius: 1,
                                    transition: 'all 0.2s',
                                    minHeight: 44,

                                    borderColor: 'grey.200',
                                    bgcolor: 'background.default',
                                    color: 'grey.900',
                                    '&:hover': {
                                        borderColor: 'grey.300',
                                        bgcolor: 'grey.50'
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        justifyContent: 'center',
                                        // border: '1px solid red',
                                        width: '100%'
                                    }}
                                >
                                    {slot.icon && (
                                        <slot.icon
                                            fontSize={'small'}
                                            color={slot.isSelected ? 'primary' : 'disabled'}
                                        />
                                    )}
                                </Box>

                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: '0.75rem',
                                        fontWeight: 500,
                                        textAlign: 'center',
                                        lineHeight: 1.2,
                                        textTransform: 'none',
                                        mt: 0.5
                                    }}
                                >
                                    {slot.label}
                                </Typography>
                            </Button>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default SEODepartureTimingFilter
